// ============================================
// APPLICATION - Consulta Boleta Hooks (público)
// ============================================

import { useMutation } from '@tanstack/react-query';
import {
  consultaBoletaRepository,
  type ConsultaBoletaPublicaPayload,
} from '../../infrastructure/http/consulta-boleta.repository';

export const useConsultarBoletaPublica = () => {
  return useMutation({
    mutationFn: (payload: ConsultaBoletaPublicaPayload) =>
      consultaBoletaRepository.consultar(payload),
  });
};
